import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import CONSTANTS from '../../misc/constants';

const LogoType = ({type}) => {
    const [logo, setLogo] = useState('');
    const [category, setCategory] = useState('');

    useEffect(()=>{
        switch (type) {
            case CONSTANTS.ENTRY_TYPES.MODELING_3D:
                setLogo("https://firebasestorage.googleapis.com/v0/b/rauru-91579.appspot.com/o/3D.svg?alt=media");
                break;
            case CONSTANTS.ENTRY_TYPES.PIXEL_ART:
                setLogo("https://firebasestorage.googleapis.com/v0/b/rauru-91579.appspot.com/o/pixel.svg?alt=media");
                break;
            case CONSTANTS.ENTRY_TYPES.WEB_DEVELOPMENT:
                setLogo("https://firebasestorage.googleapis.com/v0/b/rauru-91579.appspot.com/o/webdev.svg?alt=media");
                break;
            case CONSTANTS.ENTRY_TYPES.GAME_DEVELOPMENT:
                setLogo("https://firebasestorage.googleapis.com/v0/b/rauru-91579.appspot.com/o/gamedev.svg?alt=media");
                break;
            default:
                setLogo("https://firebasestorage.googleapis.com/v0/b/rauru-91579.appspot.com/o/basic.svg?alt=media");
                break;
        }
        setCategory(type.replace(/[ ]/g,"_"));
    },[type])
    return <Link to={`/blog/1?category=${category}`}><img src={logo} alt="LogoType" className="logo-type"/></Link>;
}
 
export default LogoType;